
import { Vue } from 'vue-class-component'

export default class Klondike extends Vue {
  startGame = false;
}
